/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import { fetchData, getTranslatedValue, toasterrormsg } from '../../../reusable'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const TourPackageDetailsHeader: React.FC = () => {
  
  const t = Tr()
  const lang = useLang()
  const location = useLocation();
  const tourpackageId = (location.state as any)?.tourpackageId || '';
  const [tourPackageDetails, setTourPackageDetails] = useState([]);

  // Tour Package Details api call
  const tourPackageDetailsApiCall=async()=>{
        
    var param:any={
        tourpackageId:tourpackageId,
    }
    var response:any=await fetchData("public/tourPackageDetails",param)
    
    if(response.status=="200")
    {
        setTourPackageDetails(response.data);
    }
    else
    {
        toasterrormsg(response.message)
    }
  }
  useEffect(()=>{
    tourPackageDetailsApiCall()
  },[tourpackageId])
  return (
    <>
    {
      tourPackageDetails.map((tourPackage:any,index:any)=>{
        var imageUrl = '';
        var totalImage = '';
        if(tourPackage['images'].length != 0){
          imageUrl = tourPackage['images'][0].mediaPath;
          totalImage = '+'+(tourPackage['images'].length-1);
        }else{
          imageUrl = toAbsoluteUrl("/media/avatars/300-1.jpg");
          totalImage = '';
        }
        return (

          <div className='card mb-5 mb-xl-10' key={index}>
            <div className='card-body pt-9 pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                <div className='me-7 mb-4'>
                  <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                    <img src={imageUrl} alt='vendor avatar' />
                    {
                      totalImage ? (
                        <div className='position-absolute translate-middle top-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-40px w-40px text-white fw-bold fs-4 p-1'>{totalImage}</div>
                      ):('')
                    }
                  </div>
                </div>

                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                    <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-2'>
                        <div className='text-gray-800 fs-2 fw-bolder me-1'>
                          {
                            getTranslatedValue(lang, tourPackage, '_agencyName')
                          }
                        </div>
                      </div>

                      <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                        <div
                          className='d-flex align-items-center text-gray-400 me-5 mb-2'
                        >
                          <KTIcon iconName='sms' className='fs-4 me-1' />
                          {tourPackage['email']}
                        </div>
                        <div
                          className='d-flex align-items-center text-gray-400 me-5 mb-2'
                        >
                          <KTIcon iconName='phone' className='fs-4 me-1' />
                          {tourPackage['phoneNo']}
                        </div>
                        <div
                          className='d-flex align-items-center text-gray-400 me-5 mb-2'
                        >
                          <KTIcon iconName='geolocation' className='fs-4 me-1' />
                          {t('Location')} : {tourPackage['location']}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='d-flex flex-wrap flex-stack'>
                    <div className='d-flex flex-column flex-grow-1 pe-8'>
                      <div className='d-flex flex-wrap'>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex overflow-auto h-55px'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/tourpackageoverview/' && 'active')
                      }
                      to='../tourpackageoverview/'
                      state={{tourpackageId:tourpackageId}}
                    >
                      {t('All Details')}
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/viewtourslist/' && 'active')
                      }
                      to='../viewtourslist/'
                      state={{tourpackageId:tourpackageId}}
                    >
                      {t('Tours')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )
      })
    }
    </>
  )
}

export {TourPackageDetailsHeader}
